export function isAlphaCharacters(str: string): boolean {
  let code;
  let i;
  let len;

  for (i = 0, len = str.length; i < len; i += 1) {
    code = str.charCodeAt(i);
    if (
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123) // lower alpha (a-z)
    ) {
      return false;
    }
  }
  return true;
}

export function extractFirstAndLastNames(namesArray: string[]): string[] {
  const first = 0;
  const last = namesArray.length - 1;
  const result: string[] = [];
  if (!namesArray || namesArray.length < 1) {
    return ['-', '-'];
  }

  // @ts-expect-error TS2345 Unchecked index access, value is possibly undefined see https://www.typescriptlang.org/tsconfig/#noUncheckedIndexedAccess
  if (namesArray[first] && !isAlphaCharacters(namesArray[first][0])) {
    namesArray.shift();
  }

  if (namesArray[last] && !isAlphaCharacters(namesArray[last])) {
    namesArray.pop();
  }

  if (namesArray.length - 1 !== last) {
    return extractFirstAndLastNames(namesArray);
  } else {
    if (namesArray[first]) {
      const firstName = namesArray[first];
      result.push(firstName);
    }

    if (first !== last && namesArray[last]) {
      const lastName = namesArray[last];
      result.push(lastName);
    }

    return result;
  }
}
// extracts first name from user full_name
export function firstNameFromFullName(fullName: string = ''): string | undefined {
  if (!fullName) {
    return undefined;
  }

  const namesArray = fullName.trim().split(' ');
  const [firstName] = extractFirstAndLastNames(namesArray);
  if (firstName === '-') {
    return undefined;
  } else {
    return firstName;
  }
}
